import { render, staticRenderFns } from "./GoTopButton.vue?vue&type=template&id=414a4ccd&scoped=true&"
import script from "./GoTopButton.vue?vue&type=script&setup=true&lang=ts&"
export * from "./GoTopButton.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "414a4ccd",
  null
  
)

export default component.exports